import React, { Component } from 'react';
import { NavLink as Link, Link as RouterLink } from 'react-router-dom';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown'
import { URL } from '../BackendApi';

import logo from './nsa-logo-new.png';
import './style.scss';

class Header extends Component {
    constructor(props) {
        super(props);

        //const bannerVisible = window.localStorage.getItem('bannerVisible');
        const bannerVisible = true;

        this.state = {
            expanded: false, 
            bannerVisible: bannerVisible === null ? true : JSON.parse(bannerVisible),
            navigation: [],
            navigationLoading: true
        }

        this.toggleNavigation = this.toggleNavigation.bind(this);
        this.navClick = this.navClick.bind(this);
        this.closeBanner = this.closeBanner.bind(this);
    }

    componentDidMount() {
        this.fetchNavigation();
    }

    fetchNavigation() {
        fetch(`${URL}/pages/navigation`)
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error('Failed to fetch navigation');
            })
            .then(data => {
                const processedNavigation = this.addKaikkiPalvelutToNavigation(data.navigation || []);
                this.setState({
                    navigation: processedNavigation,
                    navigationLoading: false
                });
            })
            .catch(error => {
                console.error('Error fetching navigation:', error);
                this.setState({
                    navigation: [],
                    navigationLoading: false
                });
            });
    }

    addKaikkiPalvelutToNavigation = (navigation) => {
        return navigation.map(item => {
            if (item.children && item.children.length > 0) {
                const processedChildren = item.children.map(child => {
                    if (child.children && child.children.length > 0 && child.main_link_title) {
                        return {
                            ...child,
                            children: [
                                { title: child.main_link_title, url: child.url + "#content", bold: true },
                                ...this.addKaikkiPalvelutToNavigation(child.children)
                            ]
                        };
                    }
                    return child;
                });
                return { ...item, children: processedChildren };
            }
            return item;
        });
    }

    renderNavigationItem = (item, index) => {
        const isMobile = window.innerWidth < 992;
        const titleWithNbsp = item.title.replace(/ /g, '\u00A0').replace(/&shy;/g, isMobile ? '\u00AD' : '');
        
        if (item.children && item.children.length > 0) {
            return (
                <NavDropdown key={index} title={titleWithNbsp} renderMenuOnMount={true} onClick={(e) => {if (e.target.tagName === "A") { window.location.href = item.url; }}}>
                    {this.renderNavigationChildren(item.children)}
                </NavDropdown>
            );
        } else {
            return (
                <Link key={index} to={item.url} exact={item.url === '/'} onClick={this.navClick} className="nav-link" activeClassName="active">
                    {titleWithNbsp}
                </Link>
            );
        }
    }

    renderNavigationChildren = (children) => {
        const isMobile = window.innerWidth < 992;
        return (
            <ul className="tree">
                {children.map((child, index) => (
                    <li key={index}>
                        {child.children && child.children.length > 0 ? (
                            <>
                                <span className="caret" onClick={this.caretClicked}>{child.title.replace(/ /g, '\u00A0').replace(/&shy;/g, isMobile ? '\u00AD' : '')}</span>
                                <ul className="nested">
                                    {this.renderNavigationChildren(child.children)}
                                </ul>
                            </>
                        ) : (
                            <span className={"bold" in child ? "link bold" : "link"}>
                                <a href={child.url}>{child.title.replace(/ /g, '\u00A0').replace(/&shy;/g, isMobile ? '\u00AD' : '')}</a>
                            </span>
                        )}
                    </li>
                ))}
            </ul>
        );
    }

    toggleNavigation = () => {
        
            if(this.state.expanded){
                this.setState({expanded: false})
            }else{
                this.setState({expanded: true});
            }
        
        
    }
    navClick = () => {
        if(window.innerWidth < 991){
            this.toggleNavigation();
        }
        const wrapper = document.getElementById('root');
        console.log(wrapper)
        if (wrapper) {
            wrapper.scrollTop = 0;
            window.scrollTo(0, 0);
            setTimeout(() => {
                wrapper.scrollTop = 0;
                window.scrollTo(0, 0);
            }, 50);
        }
        setTimeout(() => {
            wrapper.scrollTop = 0;
            window.scrollTo(0, 0);
        }, 50);
    }

    caretClicked = (e) => {
        e.preventDefault();

        e.target.parentElement.querySelector(".nested").classList.toggle("active");
        e.target.classList.toggle("active");

        const carets = e.target.parentElement.parentElement.querySelectorAll('.caret');
        carets.forEach((caret) => {
            if(caret !== e.target && caret.classList.contains('active')) {
                caret.classList.remove('active');
                caret.parentElement.querySelector(".nested").classList.remove("active");
            }
        });
    }
    
    closeBanner = (e) => {
        e.preventDefault();
        this.setState({bannerVisible: false});
        window.localStorage.setItem('bannerVisible', false);
    }

  render() {
    return (
        <header className="site-header">
        <div className={this.state.bannerVisible ? 'visible recruitment-padder' : 'recruitment-padder'}></div>
        <div className="fixed-top">
            <div id="recruitment-banner" className={this.state.bannerVisible ? 'visible' : ''}>
                <span className="rec-text">LIITY SUOMEN SUURIMMALLE YKSITYISEN TURVALLISUUSALAN REKRYLISTALLE!</span><span><Link to="/tyonhakijalle/liityrekrylistalle" className="btn-blue">LIITY TÄSTÄ</Link></span>
                <button type="button" className="close-button" onClick={this.closeBanner} aria-label="Sulje ilmoitus"><i className="fa fa-times" aria-hidden="true"></i></button>
            </div>
            <Navbar collapseOnSelect expand="lg" expanded={this.state.expanded} onToggle={()=>{}} >
                <Navbar.Brand href="/">
                    <img src={logo} alt="nordic security alliance logo" className="logo" />
                </Navbar.Brand>

                <RouterLink to="/tarjouspyynto" onClick={this.navClick} className="nav-cta mobile">Pyydä tarjous</RouterLink>
                <button onClick={this.toggleNavigation}  type="button" className={"navbar-toggle " + (this.state.expanded ? '' : 'collapsed')} data-toggle="collapse" data-target="#responsive-navbar-nav" aria-controls="responsive-navbar-nav" aria-expanded={this.state.expanded ? 'true' : 'false'} aria-label="Avaa tai sulje valikko">
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                </button>

                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="mr-auto mx-auto">
                        {this.state.navigationLoading ? (
                            <span className="nav-link">Loading...</span>
                        ) : (
                            this.state.navigation.map((item, index) => this.renderNavigationItem(item, index))
                        )}
                        <a className="intralink mobile" href="https://intra.nordicsec.fi" target="_blank" rel="noopener noreferrer">Intra</a>
                    </Nav>
                </Navbar.Collapse>

                <RouterLink to="/tarjouspyynto" onClick={this.navClick} className="nav-cta desktop">Pyydä tarjous</RouterLink>
                <a className="intralink desktop" href="https://intra.nordicsec.fi" target="_blank" rel="noopener noreferrer">Intra</a>
            </Navbar>
        </div>
        </header>
    );
  }
}

export default Header;
